import styled from "styled-components";
import { Color, Font, breakpoints } from "@/shared/Constants";


export const BtnListCollection = styled.div`
    .btn_list_collection {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 4;
    }
`;
       
